module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAZCAYAAAA4/K6pAAAABHNCSVQICAgIfAhkiAAAAUxJREFUOE+tlP1RwkAUxHc7gAokFWAHSgVqBUoFSgVqBdKB0gEdiBUIFUgHQgXrLF4yl/MOE8f3D0yy75f3TWRM0gDAM4BLAGsAjySXOS0LADuNk3cVyW2q/wGQNALwkQE7iocuAIf/mQHMSM5/BVggycLbSLwHMCK56wQIkJuoiPOcs3WlIp6H6t8DWISvbo9GkAm7AuBU7gCsAJwEkP9P644cIpB0CuA9yW8GwFU3wDMR24KkU/xOQZJFT4nIPXdL69/49RtJp9kAXgBc54aq8GxHclgsYg8QKMl5nvVxClrPxNQA/cG5dpkY4CLVLerLqgzwml709QSwJzkwwMvjNva1Jcl1M8qSPBhdWrkh2XwwBngwXjuE0boL/wooHZI0qKv4PrbWueNMTEh6Iw+WAnLHNI1gGN+FFGDy0bEm2fJJAW6lV7ho6WX+ApflgIFTukwSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/rightNav/nav/icon4.png
// module id = kcJH
// module chunks = 3